import React from "react";
import Box from "./base/Box";
import { STATUS } from "../utilities/constants";

const DocumentStatusLabel = ({ status = null, sx, ...props }) => {
  let labelColors = {};
  let label = "Pending";
  switch (status) {
    case STATUS.PREDICTED:
      labelColors = {
        color: "#14804A",
        backgroundColor: "#bdffde",
      };
      label = "Completed";
      break;
    case STATUS.ERRORED:
      labelColors = {
        color: "#a90202",
        backgroundColor: "#ffd0d0",
      };
      label = "Errored";
      break;
    case null:
      labelColors = {
        color: "darkslategray",
        backgroundColor: "lightgray",
      };
      label = "-";
      break;
    default:
      labelColors = {
        color: "#e8960f",
        backgroundColor: "#f7f6d9",
      };
  }

  return (
    <Box
      sx={{
        textAlign: "center",
        borderRadius: 20,
        textTransform: "capitalize",
        padding: "5px 10px",
        width: "fit-content",
        ...labelColors,
        ...sx,
      }}
      {...props}
    >
      {label}
    </Box>
  );
};
export default DocumentStatusLabel;
